import React from "react";
import { Route, Routes } from "react-router-dom";
import Landing from "../pages/Landing/Landing";
import PlaceOrder from "../pages/PlaceOrder/PlaceOrder";
import { useLanding } from "../pages/Landing/_hooks/useLanding";
import Payment from "../pages/Payment/PaymentScreen";


function App() {
  useLanding({ callAPI: true });

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/list/:id" element={<PlaceOrder />} />
        <Route path="/payment" element={<Payment />} />
      </Routes>
    </>
  );
}

export default App;

